<template>
	<div class="highlight-edit">
		<div class="row dynvibeRow">
			<div class="col-lg-12">
				<div class="dynvibeBox" style="min-height: 100px">
					<span class="title">Actions</span>
					<br />
					<button
						class="dynvibeButton dynvibeButton"
						@click="
							showModalEdit = true;
							errorsEdit = [];
						"
					>
						Edit titles
					</button>
					<button
						class="dynvibeButton dynvibeButtonRed"
						@click="
							showModalDelete = true;
							errorsDelete = [];
						"
					>
						Delete title
					</button>
					<button class="dynvibeButton dynvibeButtonRed" @click="deleteAll($event)">Delete all highlights</button>
					<confirm ref="confirmDelete" color="red" title="Delete" @answerconfirm="treatConfirm($event)">
						<template v-slot:confirm-body>Are you sure to delete all highlights ?</template>
					</confirm>
				</div>
			</div>

			<div v-if="showModalEdit">
				<transition name="modal">
					<div class="modal-mask">
						<div class="modal-wrapper">
							<div class="modal-dialog modal-md">
								<div class="modal-content">
									<div class="modal-header">
										<div class="col-lg-12 dynvibeTitleBox">
											<h5 class="modal-title">
												Edit title
												<button type="button" class="close" @click="showModalEdit = false">
													<span aria-hidden="true">
														<i class="icon-x"></i>
													</span>
												</button>
											</h5>
										</div>
									</div>
									<div class="modal-body">
										<div class="row dynvibeModalRowForm">
											<div class="col-lg-12">
												<select v-model="selectedEdit">
													<option value="" disabled>Title to edit</option>
													<option v-for="title in titlesAdded" :key="title" :value="title">{{ title }}</option>
												</select>
											</div>
										</div>
										<div class="row dynvibeModalRowForm">&nbsp;</div>
										<div class="row dynvibeModalRowForm">
											<div class="col-lg-12">
												<input type="text" v-model="titleEdit" class="dynvibeInputText" placeholder="New title" />
											</div>
										</div>
										<div v-if="errorsEdit.length > 0" class="row dynvibeModalRowForm">
											<div v-for="e in errorsEdit" :key="e" class="col-lg-12">
												<div class="alert alert-danger">{{ e }}</div>
											</div>
										</div>
										<div class="row dynvibeModalRowForm">
											<div class="col-lg-12">
												<button type="button" @click="editTitle()" class="btn dynvibeButton">Change title</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>

			<div v-if="showModalDelete">
				<transition name="modal">
					<div class="modal-mask">
						<div class="modal-wrapper">
							<div class="modal-dialog modal-md">
								<div class="modal-content">
									<div class="modal-header">
										<div class="col-lg-12 dynvibeTitleBox">
											<h5 class="modal-title">
												Delete title
												<button type="button" class="close" @click="showModalDelete = false">
													<span aria-hidden="true">
														<i class="icon-x"></i>
													</span>
												</button>
											</h5>
										</div>
									</div>
									<div class="modal-body">
										<div class="row dynvibeModalRowForm">
											<div class="col-lg-12">
												<select v-model="selectedDelete">
													<option value="" disabled>Title to delete</option>
													<option v-for="title in titlesAdded" :key="title" :value="title">{{ title }}</option>
												</select>
											</div>
										</div>
										<div v-if="errorsDelete.length > 0" class="row dynvibeModalRowForm">
											<div v-for="e in errorsDelete" :key="e" class="col-lg-12">
												<div class="alert alert-danger">{{ e }}</div>
											</div>
										</div>
										<div class="row dynvibeModalRowForm">
											<div class="col-lg-12">
												<button type="button" @click="deleteTitle()" class="btn dynvibeButtonRed">
													Delete title
												</button>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</transition>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "highlightedit",
	emits: ["refreshtitles", "reloadPostPage"],
	props: {
		propTitles: {},
	},
	data() {
		return {
			showModalEdit: false,
			showModalDelete: false,
			titleEdit: "",
			selectedEdit: "",
			selectedDelete: "",
			titlesAdded: {},
			errorsEdit: [],
			errorsDelete: [],
		};
	},
	components: {
		confirm: () => import("@/components/globalVue/Confirm.vue"),
	},
	mounted() {
		this.titlesAdded = this.propTitles;
		this.loadComponent(this.$store.getters.parameters);
	},
	watch: {
		propTitles: function () {
			this.titlesAdded = this.propTitles;
		},
	},
	methods: {
		loadComponent(parameters) {
			console.log(parameters);
			this.titlesAdded = this.propTitles;
		},
		updateList() {
			this.selectedEdit = "";
			this.selectedDelete = "";

			// send event to parent to refresh post list
			this.$emit("refreshtitles", this.titlesAdded);
			this.$emit("reloadposts");
		},
		editTitle(event) {
			this.errorsEdit = [];
			this.titleEdit = this.titleEdit.trim();
			if (!this.selectedEdit) {
				this.errorsEdit.push("Please select the title to edit");
			}
			if (!this.titleEdit) {
				this.errorsEdit.push("Please fill the new title");
			}

			if (Object.values(this.titlesAdded).includes(this.titleEdit)) {
				this.errorsEdit.push("This title already exists");
			}

			if (this.errorsEdit.length > 0) {
				return;
			}
			let params = new URLSearchParams();
			params.append("oldTitle", this.selectedEdit);
			params.append("newTitle", this.titleEdit);

			this.$axios.post(this.$backendUrl + "highlightEdit", params).then((response) => {
				this.showModalEdit = false;
				this.titlesAdded = response.data.titlesAdded;
				if (event) {
					event.target.blur();
				}
				this.updateList();
				this.titleEdit = "";
			});
		},
		deleteTitle(event) {
			this.errorsDelete = [];
			if (!this.selectedDelete) {
				this.errorsDelete.push("Please select the title to delete");
			}

			if (this.errorsDelete.length > 0) {
				return;
			}

			let params = new URLSearchParams();
			params.append("title", this.selectedDelete);
			this.$axios.post(this.$backendUrl + "highlightRemoveTitle", params).then((response) => {
				this.showModalDelete = false;
				this.titlesAdded = response.data.titlesAdded;
				if (event) {
					event.target.blur();
				}
				this.updateList();
			});
		},
		deleteAll() {
			this.$refs.confirmDelete.open();
		},
		treatConfirm(response) {
			if (response === "OK") {
				this.$axios.post(this.$backendUrl + "highlightDeleteAll").then(() => {
					this.titlesAdded = {};
					this.updateList();
					this.$refs.confirmDelete.close();
				});
			}
		},
	},
};
</script>

<style scoped>
.highlight-edit {
	margin-top: 10px;
	margin-bottom: 10px;
}

.modal-mask {
	position: fixed;
	z-index: 9998;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(0, 0, 0, 0.5);
	display: table;
	transition: opacity 0.3s ease;
}

.modal-wrapper {
	display: table-cell;
	vertical-align: middle;
}

.close {
	outline: 0;
}

.dynvibeBox {
	min-height: 100px;
}

.dynvibeTitleModal {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.dynvibeTitleBox {
	padding-bottom: 10px;
	margin-bottom: 0;
}

.dynvibeButtonRed {
	margin-left: 5px;
}

.title {
	margin-bottom: 0;
	font-size: 16px;
	font-weight: 700;
	color: #ef402e;
	text-transform: uppercase;
}
</style>
